import { render, staticRenderFns } from "./AddCardapio.vue?vue&type=template&id=325da9dd&"
import script from "./AddCardapio.vue?vue&type=script&lang=js&"
export * from "./AddCardapio.vue?vue&type=script&lang=js&"
import style0 from "./AddCardapio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports